import type {
    AccessOptions,
    MiddlewareMeta,
} from '~/types/access/access-types';

export function normalizeAccessOptions(
    options: MiddlewareMeta | undefined,
): AccessOptions {
    if (typeof options === 'string') {
        return {
            type: options,
            roles: [],
        };
    }

    return {
        type: options?.type ?? null,
        roles: options?.roles ?? [],
    };
}
